export const tableFooterText = (state) => {
  // return state.tableFooter.replace(/\n/g, '<br />')
  return state.tableFooter
}
